import React from 'react'
import { Select, Input } from '@baseV2'
import { strings } from '@constants'
import { FieldsRow, FieldItem, RequiredAsterisk } from './styles'

const telDigitsOnly = /^[0-9\b]+$/

const CategoryHsnRow = ({ category, hsn_code, onChange }) => {
	const handleHsnChange = (e) => {
		const value = e.target.value ?? ''
		if (value === '' || telDigitsOnly.test(value)) {
			onChange('hsn_code')(value.trim())
		}
	}

	return (
		<FieldsRow>
			<FieldItem>
				<Select
					id='enquiry-category-select'
					disabled={category?.disabled}
					label={<>{category?.label}<RequiredAsterisk>*</RequiredAsterisk></>}
					displayKey={category?.displayKey}
					primaryKey={category?.primaryKey}
					placeholder={category?.placeholder}
					data={category?.data}
					value={category?.value}
					onChange={onChange('category')}
				/>
			</FieldItem>
			<FieldItem>
				<Input
					type='tel'
					maxLength={8}
					label={hsn_code?.label}
					placeholder={strings(['enter', 'hsn', 'code'])}
					disabled={hsn_code?.disabled}
					value={hsn_code?.value}
					onChange={handleHsnChange}
				/>
			</FieldItem>
		</FieldsRow>
	)
}

export default CategoryHsnRow
